import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Moment } from "moment";
import { tap, takeUntil } from "rxjs/operators";

export interface ISelectedDates {
  id?: number | string;
  head: Moment;
  last: Moment;
  headIndex?: number;
  lastIndex?: number;
  type?: "house" | "type";
  relatedHouse?: any; // 只有在房价页面才有，代表点击的渠道id所关联的房型或房间
}

export interface ISelectedData {
  id?: number | string;
  type?: 'house' | 'type';
  thirdparty?: number;
  related?: { /** 房价才有，代表该渠道对应的房型信息 */
    relation_id: number | string;
    title: string;
    type: number;
    [prop: string]: any;
  },
  house?: { /** 房态，代表该渠道对应的房源信息 */

  },

  houseType?: {} /** 选中房型时附带的房型信息 */

}

export interface SelectedData {
  status: "none" | "doing" | "done";
  dates: ISelectedDates;
  data?: ISelectedData;
  token?: number; // 单日历用于标识发消息的个体
}

export interface HourReservationSidebarData  {
  house: {
    id: any;
    house_title: any;
    [props: string]: any;
  },
  date: string | Moment
}

export type TabName =
  | "manual-order"
  | "hostex-status"
  | "hostex-price"
  | "channel-price"
  | "channel-status"
  | "hour-room-order";

export interface ChangeOrderBelongedHouseData {
  action: 'Select' | 'Confirm' | 'Cancel',
  payload: {
    code?: string;
    index?: number;
    width?: number;
    houseId?: number;
  }
}

@Injectable({
  providedIn: 'root'
})
export class MultiHouseCalendarService {
  selectedData: SelectedData = null;

  hourReservationData = null;

  selectRaw$ = new Subject<SelectedData>();
  selectReservationRaw$ = new Subject<string>();
  selectTaskRaw$ = new Subject<any>();
  dateChangeRaw$ = new Subject<[string, string]>();
  scrollRaw$ = new Subject<number | string | Moment>();
  calendarRefreshRaw$ = new Subject();
  taskRaw$ = new Subject<{ type: "remove"; id: number }>();

  reservationRaw$ = new Subject<{ type: "remove"; code: string }>();
  sidebarTabRaw$ = new Subject<{ type: TabName, data?: any }>();

  requestUpdateAvailableRaw$ = new Subject<0 | 1>();
  requestUpdateChannelAvailableRaw$ = new Subject<{
    available: 0 | 1;
    thirdparty?: number;
  }>();

  orderBoxCountRaw$ = new Subject<number>();

  hourReservationRaw$ = new Subject<HourReservationSidebarData>();
  changeOrderBelongedHouseRaw$ = new Subject<ChangeOrderBelongedHouseData>();
  private select$ = this.selectRaw$.pipe(
    tap(value => (this.selectedData = value))
  );

  private hourReservationSidebar$ = this.hourReservationRaw$.pipe(
    tap(value => this.hourReservationData = value)
  );
  private destroy$ = new Subject();

  constructor() {
    this.select$.pipe(takeUntil(this.destroy$)).subscribe();
    this.hourReservationSidebar$.pipe(takeUntil(this.destroy$)).subscribe();
  }

  scroll(value: number | string | Moment) {
    this.scrollRaw$.next(value);
  }

  select(value: SelectedData) {
    this.selectRaw$.next(value);
  }

  selectReservation(code: string) {
    this.selectReservationRaw$.next(code);
  }

  selectTask (data: { taskId: string; date: string; houseId: number }) {
    this.selectTaskRaw$.next(data);
  }

  refresh() {
    this.calendarRefreshRaw$.next();
  }

  deleteTask(id: number) {
    this.taskRaw$.next({ type: "remove", id });
  }

  removeReservation(code: string) {
    this.reservationRaw$.next({ type: "remove", code });
  }

  changeTab(name: TabName, data?) {
    this.sidebarTabRaw$.next({ type: name , data: data });
  }

  cancelSelect() {
    this.select({
      status: "none",
      dates: {
        id: null,
        head: null,
        last: null
      }
    });
  }

  cancelSelectReservation() {
    this.selectReservation(null);
  }

  cancelSelectTask () {
    this.selectTask(null);
  }

  requestUpdateAvailable(value: 0 | 1) {
    this.requestUpdateAvailableRaw$.next(value);
  }

  requestUpdateChannelAvailable(available: 0 | 1, thirdparty?) {
    this.requestUpdateChannelAvailableRaw$.next({ available, thirdparty });
  }

  updateOrderBoxCount(number: number) {
    this.orderBoxCountRaw$.next(number);
  }

  displayHourReservationSidebar (data: HourReservationSidebarData) {
    this.hourReservationRaw$.next(data);
  }

}
